/**
 * PI Product Accordion - custom element
 * <pi-product-accordion>
 */
(function () {
  const template = document.createElement('template');
  template.innerHTML = '';

  class PiProductAccordion extends HTMLElement {
    constructor() {
      super();
      this._triggerSelector = '[data-pi-accordion-trigger]';
      this._panelSelector = '[data-pi-accordion-panel]';
    }

    connectedCallback() {
      this._triggers = this.querySelectorAll(this._triggerSelector);
      this._panels = this.querySelectorAll(this._panelSelector);
      this._bind();
    }

    _bind() {
      this._triggers.forEach((trigger, i) => {
        trigger.addEventListener('click', () => this._toggle(i));
      });
    }

    _getSingleOpen() {
      return this.getAttribute('data-pi-single-open') === 'true';
    }

    _closeAllExcept(index) {
      this._triggers.forEach((t, i) => {
        if (i === index) return;
        t.setAttribute('aria-expanded', 'false');
        if (this._panels[i]) this._panels[i].setAttribute('aria-hidden', 'true');
      });
    }

    _toggle(index) {
      const trigger = this._triggers[index];
      const panel = this._panels[index];
      if (!trigger || !panel) return;

      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      } else {
        if (this._getSingleOpen()) this._closeAllExcept(index);
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }
    }
  }

  if (!customElements.get('pi-product-accordion')) {
    customElements.define('pi-product-accordion', PiProductAccordion);
  }
})();
